<template>
    <div class="radio-buttons">
        <div class="radio-button" v-for="item in items" :key="item.id">
            <input class="radio-inline" type="radio" :id="getInputId(item.id)" v-model="internalSelectedItem" :value="item" @change="onChange">
            <label :for="getInputId(item.id)" class="radio-inline mr-3">
                {{ item.name }}
            </label>
        </div>
    </div>
</template>
<script>
    export default {
        model: {
            prop: 'selectedItem',
            event: 'change'
        },
        props: {
            items: Array,
            name: {
                type: String,
                required: false,
                default: 'radio'
            },
            selectedItem: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                internalSelectedItem: this.selectedItem
            };
        },
        methods: {
            onChange() {
                this.$emit('change', this.internalSelectedItem);
            },
            getInputId(id) {
                return `${this.name}-${id}`;
            }
        },
    };
</script>
